'use strict';

var DowConstants = {
  ALL_DOW_IDS: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
  ALL_DOW_IDS_FULL: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  ID_TO_NAME: {
    'sun': 'Su',
    'mon': 'M',
    'tue': 'T',
    'wed': 'W',
    'thu': 'Th',
    'fri': 'F',
    'sat': 'Sa'
  },
  ID_TO_DAY_OF_WEEK: {
    'mon': 1,
    'tue': 2,
    'wed': 3,
    'thu': 4,
    'fri': 5,
    'sat': 6,
    'sun': 7
  },
  NAME_TO_ID: {
    'Su': 'sun',
    'M': 'mon',
    'T': 'tue',
    'W': 'wed',
    'Th': 'thu',
    'F': 'fri',
    'Sa': 'sat',
    'Mon': 'mon',
    'Tue': 'tue',
    'Wed': 'wed',
    'Thu': 'thu',
    'Fri': 'fri',
    'Sat': 'sat',
    'Sun': 'sun'
  },
  ID_TO_NAME_FULL: {
    'Sunday': 'Su',
    'Monday': 'M',
    'Tuesday': 'T',
    'Wednesday': 'W',
    'Thursday': 'Th',
    'Friday': 'F',
    'Saturday': 'Sa'
  },
  DOW_OPTIONS: [{
    text: 'All',
    id: 'all'
  }, {
    text: 'S',
    id: 'sun',
    full: 'Sunday'
  }, {
    text: 'M',
    id: 'mon',
    full: 'Monday'
  }, {
    text: 'T',
    id: 'tue',
    full: 'Tuesday'
  }, {
    text: 'W',
    id: 'wed',
    full: 'Wednesday'
  }, {
    text: 'T',
    id: 'thu',
    full: 'Thursday'
  }, {
    text: 'F',
    id: 'fri',
    full: 'Friday'
  }, {
    text: 'S',
    id: 'sat',
    full: 'Saturday'
  }],
  DOW_OPTIONS_FULL: [{
    text: 'All',
    id: 'all'
  }, {
    text: 'S',
    id: 'Sunday'
  }, {
    text: 'M',
    id: 'Monday'
  }, {
    text: 'T',
    id: 'Tuesday'
  }, {
    text: 'W',
    id: 'Wednesday'
  }, {
    text: 'T',
    id: 'Thursday'
  }, {
    text: 'F',
    id: 'Friday'
  }, {
    text: 'S',
    id: 'Saturday'
  }]
};
module.exports = DowConstants;